export default "__VITE_ASSET__MQ53mS$___"